import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
export interface Breadcrumb {
    title: string;
    to?: string;
}

@Component({
    components: {},
})
export default class SBBreadcrumb extends Mixins(SBComponentVue) {


    @Prop({
        type: Array,
        default: [],
    })
    value!: Breadcrumb[];
}
